import { render, staticRenderFns } from "./ResultBackgroundNoPreview.vue?vue&type=template&id=11bb6fc2&"
import script from "./ResultBackgroundNoPreview.vue?vue&type=script&lang=js&"
export * from "./ResultBackgroundNoPreview.vue?vue&type=script&lang=js&"
import style0 from "./ResultBackgroundNoPreview.vue?vue&type=style&index=0&id=11bb6fc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports